export default __webpack_public_path__ + "static/media/link.a979a15c.png";